import { render, staticRenderFns } from "./DependentDetailsWrapper.vue?vue&type=template&id=61fba08d&scoped=true&lang=pug&"
import script from "./DependentDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./DependentDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fba08d",
  null
  
)

export default component.exports